import { Skeleton as ChakraSkeleton, SkeletonProps } from '@chakra-ui/react';

const Skeleton = (props: SkeletonProps) => {
  return (
    <>
      <style>{`
        @keyframes skeleton-pulse {
          0%, 100% { opacity: 0.6; }
          50%      { opacity: 1; }
        }
        .skeleton-block {
          animation: skeleton-pulse 1.5s ease-in-out infinite;
          background-color: var(--chakra-colors-button-disable) !important;
          background-image: none !important;
        }
      `}</style>

      <ChakraSkeleton
        {...props}
        startColor="button.disable"
        endColor="button.disable"
        className="skeleton-block"
      />
    </>
  );
};

export default Skeleton;
